import React from 'react';

import { CustomIconProps } from '../../src/utils/interfaces/Icon';

const ChatIcon: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox='0 0 20 20'
      fill={fill ? fill : 'currentColor'}
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M5.38047 15.8333L1.66797 18.75V3.33333C1.66797 3.11232 1.75577 2.90036 1.91205 2.74408C2.06833 2.5878 2.28029 2.5 2.5013 2.5H17.5013C17.7223 2.5 17.9343 2.5878 18.0906 2.74408C18.2468 2.90036 18.3346 3.11232 18.3346 3.33333V15C18.3346 15.221 18.2468 15.433 18.0906 15.5893C17.9343 15.7455 17.7223 15.8333 17.5013 15.8333H5.38047ZM4.8038 14.1667H16.668V4.16667H3.33464V15.3208L4.8038 14.1667ZM6.66797 8.33333H13.3346V10H6.66797V8.33333Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default ChatIcon;
